import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>Empowering Communities, Transforming Lives</h1>
        <p>Pramila Foundation is dedicated to creating positive change through education, sports, environmental protection, and social welfare initiatives.</p>
        <div className="hero-buttons">
          <Link to="/about" className="btn primary-btn">Learn More</Link>
          <Link to="/our-team" className="btn secondary-btn">Our Team</Link>
        </div>
      </div>
    </section>
  );
}

export default Hero;
